// extracted by mini-css-extract-plugin
export default {"root":"SectionSimpleContainer_root__xtgvK","content":"SectionSimpleContainer_content__4VHTm","gridContainer":"SectionSimpleContainer_gridContainer__5PDq4"};